/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { AiAssistantCallControllerService } from './services/ai-assistant-call-controller.service';
import { AiFunctionControllerService } from './services/ai-function-controller.service';
import { AuthControllerService } from './services/auth-controller.service';
import { ChannelMessageControllerService } from './services/channel-message-controller.service';
import { ChannelControllerService } from './services/channel-controller.service';
import { FlightControllerService } from './services/flight-controller.service';
import { HotelControllerService } from './services/hotel-controller.service';
import { MessageTemplateManagementControllerService } from './services/message-template-management-controller.service';
import { ParticipantControllerService } from './services/participant-controller.service';
import { PingControllerService } from './services/ping-controller.service';
import { TourParticipantControllerService } from './services/tour-participant-controller.service';
import { TourControllerService } from './services/tour-controller.service';
import { UiMenuItemControllerService } from './services/ui-menu-item-controller.service';
import { WhatsappControllerService } from './services/whatsapp-controller.service';
import { WorkflowManagementControllerService } from './services/workflow-management-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    AiAssistantCallControllerService,
    AiFunctionControllerService,
    AuthControllerService,
    ChannelMessageControllerService,
    ChannelControllerService,
    FlightControllerService,
    HotelControllerService,
    MessageTemplateManagementControllerService,
    ParticipantControllerService,
    PingControllerService,
    TourParticipantControllerService,
    TourControllerService,
    UiMenuItemControllerService,
    WhatsappControllerService,
    WorkflowManagementControllerService,
    ApiConfiguration
  ],
})
export class ApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
